import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import styles from "./LoadMore.module.scss";
export const LoadMore = forwardRef(({ label = "Load more", expanded, ...props }, ref) => {
    return (_jsxs("button", { ...props, className: classNames(styles.button, props.className), ref: ref, children: [label, _jsx(ChevronDownIcon, { className: classNames(styles.icon, { [styles.expanded]: expanded }) })] }));
});
//# sourceMappingURL=LoadMore.js.map